export const PERCENT_FORMAT = '%';
export const BLANK_VALUE = '—';